/* global debounce */
if (!customElements.get('cart-upsell-products')) {
  class CartUpsellProducts extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
        theme.manuallyLoadImages(this);
        this.querySelectorAll('cart-upsell-products').forEach((el) => el.init());
    }
  }

  customElements.define('cart-upsell-products', CartUpsellProducts);
}